<script>
    
	import { onMount } from 'svelte';
    
    onMount(() => {
        window.scrollTo(0, 0);
    });
   
</script>


<div class="container">
    <h2>Credits</h2>

    <h3>Data Sources</h3>
    <p>
        <a target="_blank" href="https://www.kaggle.com/rohanrao/formula-1-world-championship-1950-2020">Formula 1 World Championship (1950 - 2022)</a> by 
        <a target="_blank"href="https://www.kaggle.com/rohanrao">Vopani</a> on 
        <a target="_blank" href="https://www.kaggle.com/">Kaggle</a>
    </p>
    
    <h3>Images</h3>     
    <p>
        <a target="_blank" href="https://thenounproject.com/browse/collection-icon/motoracing-circuits-148580?p=1">Motoracing Circuits</a> by 
        <a target="_blank" href="https://thenounproject.com/tom.fricker/">Tom Fricker</a> on 
        <a target="_blank" href="http://thenounproject.com/">the Noun Project</a>
    <br>  
        <a target="_blank" href="https://thenounproject.com/icon/f1-helmet-2135602/">F1 Helmet</a> favicon by 
        <a target="_blank" href="https://thenounproject.com/kokota.icon/">Kokota</a> on 
        <a target="_blank" href="http://thenounproject.com/">Wikimedia</a>
    <br>
        Car Images by <a href="https://www.formula1.com/">Formula 1</a>
    <br>    
        <a target="_blank" href="https://unsplash.com/photos/SKUhsXRpSL0">Red Bull Car Title Photo</a> by 
        <a target="_blank" href="https://unsplash.com/@teapowered?utm_source=unsplash&amp;utm_medium=referral&amp;utm_content=creditCopyText">Patrick Robert Doyle</a> on 
        <a target="_blank" href="https://unsplash.com/s/photos/formula-one?utm_source=unsplash&amp;utm_medium=referral&amp;utm_content=creditCopyText">Unsplash</a>
    <br>
        <a target="_blank" href="https://commons.wikimedia.org/wiki/File:Max_Verstappen_2017_Malaysia_1.jpg">Max Verstappen Headshot</a> by 
        <a target="_blank" href="https://commons.wikimedia.org/wiki/User:Morio">Morio</a> on 
        <a target="_blank" href="https://commons.wikimedia.org/">Wikimedia</a>
    <br>    
        <a target="_blank" href="https://commons.wikimedia.org/wiki/File:Lewis_Hamilton_2016_Malaysia_2.jpg">Lewis Hamilton Headshot</a> by 
        <a target="_blank" href="https://commons.wikimedia.org/wiki/User:Morio">Morio</a> on 
        <a target="_blank" href="https://commons.wikimedia.org/">Wikimedia</a>
    </p>       

    <h3>Audio</h3>
    <p>
        <a target="_blank" href="https://www.zapsplat.com/music/loud-thunder-clap-close-up/">Thunder Clap</a> on 
        <a target="_blank" href="https://www.zapsplat.com/">Zapsplat</a>
    <br>
        <a target="_blank" href="https://freesfx.co.uk/sfx/formula">F1 Car Sounds</a> on 
        <a target="_blank" href="https://freesfx.co.uk/">FreeSFX</a>
    </p>

    <h3>Fonts</h3>    
    <p>
        <a target="_blank" href="https://fonts.google.com/specimen/Poppins">Poppins</a> by 
        <a target="_blank" href="https://fonts.google.com/?query=Indian%20Type%20Foundry">Indian Type Foundry</a>,
        <a target="_blank" href="https://fonts.google.com/?query=Jonny%20Pinhorn">Jonny Pinhorn</a> on
        <a target="_blank" href="https://fonts.google.com/">Google Fonts</a>
    <br>
        <a target="_blank" href="https://fonts.google.com/specimen/Titillium+Web">Titillium Web</a> by 
        <a target="_blank" href="https://fonts.google.com/?query=Accademia%20di%20Belle%20Arti%20di%20Urbino">Accademia di Belle Arti di Urbino</a> on 
        <a target="_blank" href="https://fonts.google.com/">Google Fonts</a>
    
    <h3>Inspiration</h3>
    <p>
        <a target="_blank" href="https://www.imdb.com/title/tt8289930/">Formula 1: Drive to Survive</a> on <a target="_blank" href="https://www.netflix.com/title/80204890">Netflix</a> 
        is so well produced, crafted, and delivered. It is responsible for catalysing my interest in Formula 1 racing.
    <br>
        <a target="_blank" href="https://www.kaggle.com/jtrotman">James Trotman</a>'s <a target="_blank" href="https://www.kaggle.com/jtrotman/f1-race-traces-2021">Race Traces</a> were  the inspiration behind lightning plots. Though my calculation is slightly different, they are essentially the same plot turned on it's side.
    </p>

    <h3>Acknowlegements</h3>
    <p>I couldn't have done this without frequently bastardizing the code made generously available by the kind folks at <a target="_blank" href="https://pudding.cool/">The Pudding</a>. Thanks for the repos and the videos that helped me flail my way here, <a target="_blank" href="https://pudding.cool/author/russell-goldenberg/">Russell Goldenberg</a> and <a target="_blank" href="https://wattenberger.com/">Amelia Wattenberger</a>. 
    <p>Thanks also to <a target="_blank" href="https://mobile.twitter.com/robkorzan">Rob Korzan</a> and <a target="_blank" href="https://mobile.twitter.com/ideaowl">Eugene Chen</a> for providing feedback on the site. 
    <p>And to my wife and children for encouraging me and making sure I fed and watered myself on days where I was particularly stuck on something.


    <h3>Contact</h3>
    <p>joeycherdarchuk@gmail.com</p>

    
    <p class="disclaimer">DISCLAIMER: This website is unofficial and is not associated in any way with the Formula 1 companies. F1, FORMULA ONE, FORMULA 1, FIA FORMULA ONE WORLD CHAMPIONSHIP, GRAND PRIX and related marks are trade marks of Formula One Licensing B.V.</p>
    <div class="spacer" style="height: 50px"></div>

    <div class="pageNav">
        <div class="links">
            <a href="/">Back</a> &nbsp;&nbsp;&nbsp;&nbsp;| &nbsp;&nbsp;&nbsp;&nbsp;<a href="/about">About Me</a>
            <div style="display:inline; float:right; "><a href="mailto:joeycherdarchuk@gmail.com" style="text-transform:lowercase; font-family:'Titillium Web', sans-serif">joeycherdarchuk@gmail.com</a></div>
        </div>
    </div> 

</div>


<style>

    .container {
	  max-width: 900px;
	  margin: 0 auto;
      padding: 40px;
    }


    h2 {
        font-size: 36px;
        line-height: 40px;
    }

    h3 {
        font-family: 'Poppins', 'Arial Black', sans-serif;
        margin-top: 2em;
        margin-bottom: 0;
        text-transform: uppercase;
        letter-spacing: 0.05em;
        font-size: 16px;
        font-weight: 800;
        height: auto;
        color:  #9CBCE0;;
    }

    p {
        margin: 0 0 1em 0;
        font-size: 14px;
    }

    a {
        color: #F0B8C9;
        border-bottom: 1px dashed #FF285D55;
    }
    
    a:hover {
        text-decoration: none;
        border-bottom: 1px dashed #FF285D;
    }

    .disclaimer {
        font-size: 12px; 
        color:#999; 
        margin-top: 40px;
    }

    .pageNav {
        position: fixed;
        bottom: 0;
        left: 0;
        font-size: 12px;
        font-family: 'Poppins', 'Century Gothic', sans-serif;
        background-color: #1B1F22;
        width: 100%;
        padding: 15px 0;
        /* border-top: solid 1px #222; */
    }

    .pageNav a {
        color: #9CBCE0;
        text-transform: uppercase;
        border: none;
    }
    
    .pageNav a:hover {
        text-decoration: none;
        border-bottom: 1px dashed #9CBCE0;
    }

    .links {
	  max-width: 900px;
	  margin: 0 auto;
      padding: 0 40px;
    }
</style>